module.exports = __webpack_public_path__ + "static/media/afrogirl.4b338b81.png";